import React from 'react'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import InputFieldListItem from '../1elements/Fields/InputFieldListItem'
import IconButton from '@mui/material/IconButton'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { makeStyles } from '@material-ui/core/styles'
/**
 * @param {} index
 * @param {} primaryContent
 * @param {} itemConfig
 * @param {} onEditMode
 * @param {} deleteHandler
 * 
 * Sample controlArray
   [{
      type:'date', 
      baseName:'date[INDEX].someKey',
      disabled: false
    },{
      type:'url', 
      baseName:'url[INDEX].someKey',
      disabled: false
    },{
      type:'text', 
      baseName:'text[INDEX].someKey',
      disabled: false
  },{
      type:'select', 
      baseName:'select[INDEX].someKey', 
      optionsList:[
        {value:'someuuid1', text:'someName1'},
        {value:'someuuid2', text:'someName2'}
      ],
      disabled: false
  }]
 */

/**
 * Sample Code
   <DecoratedListItemItems
     index={index}
     primaryContent={primaryContent}
     itemConfig={itemConfig}
     onEditMode={!disabled}
     deleteHandler={deleteHandler}
   /> 
 */

const DecoratedListItemItems = ({
  index,
  itemName,
  itemConfig,
  onEditMode,
  formikProps,
  deleteHandler
}) => {
  const clacInputWidth = (itemsCount = itemConfig?.controlArray?.length) =>
    itemsCount ? 100 / (itemsCount + 1) : 100
  const classes = useStyles({ columnWidth: clacInputWidth() })

  return (
    <>
      <div className={classes.contentWrapper}>
        {/* The Text */}
        <div className={classes.contentText}>{itemName}</div>
        {/* The Elements */}
        {Array.isArray(itemConfig?.controlArray) &&
          itemConfig.controlArray.map((item, idx) => {
            const { type, baseName, optionsList, disabled } = item

            // If the name refers to a nested element then we need to break it down
            let arrayProps = undefined
            if (baseName.includes('[INDEX]') && baseName.includes('.')) {
              const parsedString = baseName.split('.')
              const parsedArrayString = parsedString[0].split('[INDEX]')
              arrayProps = {
                name: `${parsedArrayString[0]}`,
                index: `${index}`,
                field: `${parsedString[1]}`
              }
            }

            // INDEX in the string is replaced with the value of the index
            const name = baseName.replace('INDEX', index)

            // The Value for the element
            const elementValue = arrayProps
              ? formikProps.values[arrayProps.name] &&
                formikProps.values[arrayProps.name][arrayProps.index] &&
                formikProps.values[arrayProps.name][arrayProps.index][
                  arrayProps.field
                ]
              : formikProps.values[name]

            return (
              <div key={`item_${name}${idx}`} className={classes.contentInput}>
                <InputFieldListItem
                  type={type}
                  name={name}
                  required={true}
                  editMode={!disabled && onEditMode}
                  options={optionsList}
                  setFieldValue={formikProps.setFieldValue}
                  value={elementValue}
                  values={formikProps.values}
                />
              </div>
            )
          })}
      </div>
      {/* The Close Button */}
      <div className={classes.deleteButtonWrrapper}>
        {deleteHandler && onEditMode && (
          <ListItemSecondaryAction>
            <IconButton
              edge='end'
              aria-label='delete'
              className={classes.deleteButton}
              onClick={index => deleteHandler(index)}
            >
              <HighlightOffIcon />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </div>
    </>
  )
}

export default React.memo(DecoratedListItemItems)

const useStyles = makeStyles((theme, props) => ({
  contentWrapper: {
    width: '90%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  contentText: {
    width: props => `${props.columnWidth}%`,
    padding: '0 3px',
    // ...theme.typography.h9
    fontSize: '15px',
    fontWeight: 500,
    color: '#2C2C2C',
    wordWrap: 'break-word'
  },
  contentInput: {
    width: props => `${props.columnWidth}%`,
    padding: '0 3px'
  },
  deleteButtonWrrapper: {
    width: '10%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  deleteButton: {
    padding: '12px 0'
  }
}))
